import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";
import CheckIcon from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleEditCard/components/VehicleWizardIntro/scenes/CheckIcon";

import { NotificationSceneProps } from "../types";

/** Zadnji korak: popis postavki s kvačicama, pa naslov obavijesti i status. */
const NotificationSummaryScene: React.FC<NotificationSceneProps> = ({ notification, isEdit }) => {
  const recipientCount = notification.roleCount + notification.userCount;
  const rows = [
    { label: "Grupa", value: notification.entityLabel },
    { label: "Kanali", value: notification.activeChannelLabels.join(", ") },
    { label: "Primatelji", value: recipientCount > 0 ? `${recipientCount} odabrano` : "Nije odabrano" },
    {
      label: "Slanje",
      value: notification.isCustom ? notification.customDate : `${notification.daysBeforeExpiry} dana prije`,
    },
  ];

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Pregled</div>
          <div className="text-sm font-bold text-slate-800 truncate">{notification.title}</div>
          <div className="mt-3 space-y-2">
            {rows.map((row) => (
              <div key={row.label} className="flex items-center gap-2 rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
                <CheckIcon />
                <span className="text-slate-500">{row.label}</span>
                <span className="ml-auto font-semibold text-slate-800 truncate">{row.value}</span>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Status</div>
          <div className="mt-2 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500" />
            <span className="text-xs font-bold text-slate-800">Aktivna</span>
          </div>
          <div className="mt-1 text-[0.65rem] leading-relaxed text-slate-400">
            {isEdit ? "Promjene vrijede od sljedećeg slanja." : "Počinje raditi odmah nakon spremanja."}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Šalje se samo"
          subtitle="Rokove provjeravamo svaki dan"
          iconClassName="bg-emerald-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#047857" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 7v5l3 2" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(NotificationSummaryScene);
